import { render, staticRenderFns } from "./sentenceM4.vue?vue&type=template&id=01b07c8a&scoped=true&"
import script from "./sentenceM4.vue?vue&type=script&lang=js&"
export * from "./sentenceM4.vue?vue&type=script&lang=js&"
import style0 from "./sentenceM4.vue?vue&type=style&index=0&id=01b07c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b07c8a",
  null
  
)

export default component.exports